

<button
id="close-footbar"
type="button"
class="close"
aria-label="Close"
[mat-dialog-close]="false">
<span aria-hidden="true">×</span>
</button>
<h2 mat-dialog-title> {{ 'k003343' | translate }}</h2>
<mat-dialog-content class="content">
  <div *ngIf="Conflict == null">
    <p>{{ 'k003344' | translate }} </p>
    <p [innerHTML]="SectionsToComplete"> </p>
    <p>{{ 'k003345' | translate }}</p>
  </div>
  <div *ngIf="Conflict!= null">
    <p [innerHTML]="Conflict"></p>
  </div>
</mat-dialog-content>
